import { render, staticRenderFns } from "./sync.vue?vue&type=template&id=54971f1e&scoped=true&"
import script from "./sync.vue?vue&type=script&lang=js&"
export * from "./sync.vue?vue&type=script&lang=js&"
import style0 from "./sync.vue?vue&type=style&index=0&id=54971f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54971f1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54971f1e')) {
      api.createRecord('54971f1e', component.options)
    } else {
      api.reload('54971f1e', component.options)
    }
    module.hot.accept("./sync.vue?vue&type=template&id=54971f1e&scoped=true&", function () {
      api.rerender('54971f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/draftCopy/components/sync.vue"
export default component.exports